import React from 'react';
import useContentfulLocale from 'components/useContentfulLocale';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { useQuery } from 'react-query';
import useSiteCopySelector from 'components/useSiteCopySelector';
import { replacePlaceholders, getUserFirstName } from 'utils/stringUtils';
import { useSelector } from 'react-redux';
import { getListsFn, getTopicsInfoFn } from '../services/getList';
import Resources from './Resources';

const PersonalizedLanding = ({ grayscale, profile }) => {
  const profileOnboarding = _get(profile, 'onboarding');
  const selectedList = _get(profileOnboarding, 'lists.0');
  const selectedTopics = _get(profileOnboarding, 'topics');
  const ctfLocaleFilter = useContentfulLocale();
  const [siteCopy] = useSiteCopySelector(['onboarding-questions']);
  const clientDetails = useSelector(state => state.main.clientDetails);
  const onboardingConfig = _get(siteCopy, 'pageCopy');
  const listsConfig = _get(onboardingConfig, 'lists', []);
  const landingConfig = _get(onboardingConfig, 'landing', {});
  const changePlanLinkLabel = _get(landingConfig, 'changePlanLinkLabel');
  const resourcesTitle = _get(landingConfig, 'resourcesTitle');
  const approachTitle = _get(landingConfig, 'approachTitle');
  const name = getUserFirstName(profile);
  const clientExcludedTopicIds = _get(
    clientDetails,
    'excludeTopicCollection.items',
    [],
  ).map(s => s.sys.id);

  const listsIds = listsConfig.map(list => {
    const [listKey] = Object.keys(list).filter(key => key !== 'list-resources');
    return list[listKey];
  });
  const selectedListIndex = listsIds.indexOf(selectedList);
  const selectedListResourcesId =
    selectedListIndex >= 0
      ? _get(listsConfig[selectedListIndex], 'list-resources')
      : null;

  const { data: lists = [] } = useQuery(
    selectedList && [
      'landing-onboarding-lists',
      {
        listsIds: [selectedList],
        clientExcludedTopicIds,
        localeFilters: ctfLocaleFilter,
      },
    ],
    getListsFn,
  );
  const { data: listResources = [] } = useQuery(
    selectedListResourcesId && [
      'list-resources',
      {
        listsIds: [selectedListResourcesId],
        localeFilters: ctfLocaleFilter,
        isResources: true,
      },
    ],
    getListsFn,
  );
  const topicsQuery = useQuery(
    !_isEmpty(selectedTopics) && [
      'topics-info',
      selectedTopics,
      ctfLocaleFilter,
    ],
    getTopicsInfoFn,
    { isDataEqual: () => false },
  );

  if (_isEmpty(lists)) return null;
  const listInfo = _get(lists, '0');
  const {
    fields: { title, shortTitle },
  } = listInfo;
  const { data: topics = [] } = topicsQuery;
  const approachPlaceholderTitle =
    _get(topics[0], ['fields', 'shortTitle']) ||
    _get(topics[0], ['fields', 'title'], '');
  const placeholdersMap = {
    '#name': name,
    '#list': (shortTitle || title).toLowerCase(),
    '#approach': approachPlaceholderTitle.toLowerCase(),
  };

  return (
    <Resources
      title={replacePlaceholders(resourcesTitle, placeholdersMap)}
      approachTitle={
        topics.length === 1
          ? replacePlaceholders(approachTitle, placeholdersMap)
          : null
      }
      topicsQuery={topicsQuery}
      buttonLabel={changePlanLinkLabel}
      listResources={listResources}
      listInfo={listInfo}
      grayscale={grayscale}
    />
  );
};

export default PersonalizedLanding;
